import React from 'react';

import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import { Mutation } from 'react-apollo';

import ErrorModal from '../ErrorModal';
import MutationRequest from '../MutationRequest';

export const ADD_FAVORITE_ASSET = gql`
  mutation AddAssetToFavorite($assetId: String!) {
    user {
      addFavouriteAsset(assetId: $assetId)
    }
  }
`;

const addAssetToFavRequest = ({ assetId, onError, onSuccessResult }) => (
  <Mutation mutation={ADD_FAVORITE_ASSET}>
    {(AddAssetToFavorite, { loading, error, data }) => {
      const variables = {
        assetId,
      };

      if (error) {
        return <ErrorModal error={error} onError={onError} />;
      }
      if (data) {
        onSuccessResult(data.user.addFavouriteAsset);
      }

      return (
        <MutationRequest
          isLoading={loading}
          mutation={AddAssetToFavorite}
          variables={variables}
        />
      );
    }}
  </Mutation>
);

addAssetToFavRequest.propTypes = {
  assetId: PropTypes.string.isRequired,
  onError: PropTypes.func.isRequired,
  onSuccessResult: PropTypes.func.isRequired,
};

export default addAssetToFavRequest;
